<template>
    <div v-if="comment !== undefined && comment !== ''" class="content">
        <div class="cell small-16">
        <div :class="'callout'+' '+type">
            <div class="callout-icon">
            <div v-if="type=='alt' || type=='transparent'"><img src="../../../assets/images/icons/icon-info.svg" alt="info"></div>
            <div v-else><img src="../../../assets/images/icons/icon-info-white.svg" alt="info"></div>
            <div><span class="icon-pad">
               {{comment}}</span></div>
            </div>
        </div>
        </div>
    </div>
</template>
<script>
export default {
   name:'callouts-Component',
   props:{
     type:{
         type:String
     },
     comment:{
         type:String,
         default: undefined
     }
   }
}
</script>
